import React from 'react'
import PieChartIcon from '@material-ui/icons/PieChartOutlined'
import { createColumnInstance } from '../../constants'

// Module-level instance keeps the React Query cache key stable across
// renders; resolvers must not mint fresh ids each call.
const MEASURE = createColumnInstance('marketValue')

export const allocationByMarketValue = Object.freeze({
  id: 'allocation-mv',
  name: 'Allocation by Market Value',
  description: 'Donut of Market Value across the top grouping.',
  renderIcon: () => <PieChartIcon style={{ fontSize: 16 }} />,
  toolId: 'allocation',
  resolve: ({ config }) => ({
    ok: true,
    payload: {
      scope: 'level',
      depth: 0,
      groupingLabel: config?.groupings?.[0] || null,
      measureColumnInstance: MEASURE,
      chartType: 'donut'
    }
  })
})
